export enum SpaceRoutes {
  index = '/:lang',
  admin = '/:lang/admin',
  adminLogin = '/:lang/admin/login',
  survey_not_found = '/:lang/survey-not-found',
  support = '/:lang/support',
  Information = '/:lang/information',
  Accessibility = '/:lang/accessibility',
  surveysReportDownload = '/:lang/surveys/general-report-download',
  TwoFaSetup = '/:lang/2fa-setup',
  ResetPassword = '/:lang/reset-pw/:token/:email/:role'
}